// extracted by mini-css-extract-plugin
export default {"title":"create_title__Hsgc3","container":"create_container__PX+4h","header":"create_header__bG4M2"};